import React, { useState, useEffect } from 'react';
import styles from './Countdown.module.css';

const Countdown: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const targetDate = new Date('2026-05-09T16:00:00').getTime();

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className={styles.countdown}>
      <div className="container">
        <div className={styles.countdownContent}>
          <h3 className={styles.countdownTitle}>Faltan</h3>
          <div className={styles.countdownGrid}>
            <div className={styles.countdownItem}>
              <span className={styles.countdownNumber}>{timeLeft.days}</span>
              <span className={styles.countdownLabel}>DÍAS</span>
            </div>
            <div className={styles.countdownItem}>
              <span className={styles.countdownNumber}>{timeLeft.hours}</span>
              <span className={styles.countdownLabel}>HRS</span>
            </div>
            <div className={styles.countdownItem}>
              <span className={styles.countdownNumber}>{timeLeft.minutes}</span>
              <span className={styles.countdownLabel}>MIN</span>
            </div>
            <div className={styles.countdownItem}>
              <span className={styles.countdownNumber}>{timeLeft.seconds}</span>
              <span className={styles.countdownLabel}>SEG</span>
            </div>
          </div>
          <p className={styles.countdownSubtitle}>para mis xv años</p>
        </div>
      </div>
    </section>
  );
};

export default Countdown;